/**

 * Driver / logistics admin UI: en-route Loads.Status is shown as **In Transit**.

 */

export const LOAD_STATUS_IN_TRANSIT_DISPLAY = 'In Transit';

// Legacy DB value previously used for the in-transit phase.
const LEGACY_IN_TRANSIT_RAW = ['s', 'h', 'i', 'p', 'p', 'e', 'd'].join('');

function isLegacyInTransitRaw(s) {
  const raw = s != null ? String(s).trim() : '';
  if (!raw) return false;
  const compact = raw.replace(/\s+/g, '').toLowerCase();
  return compact === 'intransit' || compact === LEGACY_IN_TRANSIT_RAW;
}



/** Admin deliveries filter: all Loads.Status values except Delivered and en-route (In Transit). */

export const LOAD_STATUS_FILTER_OTHER = 'Other';



/**

 * Label for **logistics / driver-facing** surfaces (Deliveries, etc.):

 * In Transit → "In Transit".

 */

export function loadStatusDisplayFromRaw(raw) {

  const s = raw != null ? String(raw).trim() : '';

  if (!s) return '—';

  if (isLegacyInTransitRaw(s) || s === LOAD_STATUS_IN_TRANSIT_DISPLAY) return LOAD_STATUS_IN_TRANSIT_DISPLAY;

  return s;

}



/**

 * Label for **project loads, reports, and release lists** on the main app:

 * **In Transit** → **In Transit** (same as driver/logistics); **Final** → **Certified**; otherwise as stored.

 */

export function loadStatusDisplayAsStored(raw) {

  const s = raw != null ? String(raw).trim() : '';

  if (!s) return '—';

  // Display-only: DB value remains "Final"
  if (s.toLowerCase() === 'final') return 'Certified';

  return loadStatusDisplayFromRaw(raw);

}



/**
 * Normalize load status strings for comparisons (case/spacing/punctuation tolerant).
 * Examples:
 * - "In Transit" / "In-Transit" / "INTRANSIT" -> "intransit"
 * - "Auth req'd" / "Auth Req'd" -> "authreqd"
 */
export function normalizeLoadStatusKey(rawStatus) {
  const s = rawStatus != null ? String(rawStatus).trim().toLowerCase() : '';
  if (!s) return '';
  return s.replace(/[^a-z0-9]+/g, '');
}

const LOGISTICS_BADGE_BASE = 'logistics-status-badge';

/**
 * Load workflow status badge props for Bootstrap `Badge`.
 * Custom colors use `bg: null` (avoids Bootstrap default `bg-primary`) + `className` (see `fe/src/index.css`).
 */
export function deliveriesLoadStatusBadgeProps(rawStatus) {
  const key = normalizeLoadStatusKey(rawStatus);
  if (!key) return { bg: 'secondary', text: undefined, className: undefined };

  const custom = (suffix, text) => ({
    bg: null,
    text,
    className: `${LOGISTICS_BADGE_BASE} ${LOGISTICS_BADGE_BASE}--${suffix}`,
  });

  if (key === 'delivered') return custom('delivered', 'white');
  if (key === 'fabricated') return custom('fabricated', 'white');
  if (key === 'firmed') return custom('firmed', 'white');
  if (key === 'certified' || key === 'final') return custom('certified', 'white');
  if (key === 'reserved') return custom('reserved', 'dark');
  if (key === 'tagged') return custom('tagged', 'white');

  // In transit (including legacy "Shipped" spelling and display label)
  if (key === 'intransit' || isLegacyInTransitRaw(rawStatus)) {
    return custom('intransit', 'white');
  }

  // Auth required variants
  if (key === 'authreqd' || key === 'authenticationrequired' || key === 'authrequired') {
    return custom('authreqd', 'white');
  }

  return { bg: 'secondary', text: undefined, className: undefined };
}

/**
 * Bootstrap `Badge` `bg` for load workflow status — keys off **raw** API/DB value
 * so en-route is primary whether the visible label is In Transit.
 */
export function loadStatusBadgeBg(rawStatus) {
  const { bg } = deliveriesLoadStatusBadgeProps(rawStatus);
  return bg == null ? 'secondary' : bg;
}


